define('connections/profile-connection',['jquery', 'utils/ajax-util', 'settings'], function ($, ajax, settings) {
  /**
   * @class ProfileConnection
   */
  return (function () {
    /**
     * @constructor
     */
    function ProfileConnection() {}

    ProfileConnection.prototype.setPreferredColor = function (color) {
      return ajax.post(settings.profileApiUrl + '/preferredColor', color);
    };

    ProfileConnection.prototype.showPrice = function (priceType) {
      return ajax.post(settings.profileApiUrl + '/showPrice', priceType);
    };

    ProfileConnection.prototype.removeActingRole = function () {
      return ajax.post(settings.removeActingRoleApiUrl);
    };

    ProfileConnection.prototype.setActingRole = function (customerEmail) {
      var encodedCustomerEmail = encodeURIComponent(customerEmail);
      return ajax.post(settings.setActingRoleApiUrl + encodedCustomerEmail);
    };

    ProfileConnection.prototype.searchCustomers = function (search) {
      return ajax.get(settings.sellerCustomersApiUrl + '?search=' + search);
    };

    ProfileConnection.prototype.getUserInfo = function (params) {
      return ajax.post(settings.profileValidationApiUrl, params);
    };

    ProfileConnection.prototype.getUserContact = function (params) {
      // Using ajax explicitly to avoid auto error display on not found contactcd
      return ajax.ajax('GET', settings.profileApiUrl + '/customerContact', null, null, function () {});
    };

    return new ProfileConnection();
  })();
});

